import { render, staticRenderFns } from "./KidDetails.vue?vue&type=template&id=7174d3e0&scoped=true&"
import script from "./KidDetails.vue?vue&type=script&lang=js&"
export * from "./KidDetails.vue?vue&type=script&lang=js&"
import style0 from "./KidDetails.vue?vue&type=style&index=0&id=7174d3e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7174d3e0",
  null
  
)

export default component.exports